import { IOrderRepositoryDB } from "../../../domains/order/interfaces/repositories/IOrderRepositoryDB";
import { OrderRepositoryLocalStorageV2 } from "./OrderRepositoryLocalStorageV2";

// V1 foi descontinuado — ver useOrdersMigration para a migração dos dados legados.
export const getOrderRepository = (): IOrderRepositoryDB => {
  return OrderRepositoryLocalStorageV2();
};
